import {Injectable, Injector, NgZone} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {AssistantModelService} from '../../Models/Assistant/assistant-model.service';
import {AssistantMessageDto} from '../../../Models/Assistant/assistant-message.interface';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssistantApiService extends BaseApiService {

  protected baseUrlAsst: string = environment.baseUrlAsst;

  constructor(
    protected override injector: Injector,
    protected zone: NgZone,
    public model: AssistantModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener el listado de conversaciones
   *
   */
  public getConversations(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpBaseCall('conversations', {}, 'get', this.baseUrlAsst).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener la conversación
   *
   */
  public getConversation(conversationId: string): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpBaseCall(`conversations/${conversationId}`, {}, 'get', this.baseUrlAsst).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Renombrar una conversación
   *
   */
  public renameConversation(conversation: {id: string, title: string}): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpBaseCall(`conversations/${conversation.id}`, {title: conversation.title}, 'put', this.baseUrlAsst).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar una conversación
   *
   */
  public deleteConversation(conversationId: string): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpBaseCall(`conversations/${conversationId}`, {}, 'delete', this.baseUrlAsst).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Enviar un mensaje
   *
   */
  public sendMessage(message: AssistantMessageDto): Promise<ApiResponse> {

    const endpoint: string = `conversations/${message.conversation_id}/messages/${message.id}`;

    return new Promise((resolve, reject) => {

      return this.httpBaseCall(endpoint, message, 'put', this.baseUrlAsst).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Establecer una conexión
   *
   */
  connectStream(conversationId: string): Observable<string> {

    return new Observable((observer) => {

      const source: EventSource = new EventSource(this.baseUrlAsst + `conversations/${conversationId}/stream`);

      source.onmessage = (event) => {
        this.zone.run(() => {
          observer.next(event.data);
        });
      };

      source.onerror = () => {
        this.zone.run(() => {
          source.close();
          observer.error();
        });
      };

      return () => {
        source.close();
      };

    });

  }

}
